import { render, staticRenderFns } from "./OsDesktop.vue?vue&type=template&id=6f656376&"
import script from "./OsDesktop.vue?vue&type=script&lang=js&"
export * from "./OsDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports